import { store } from '@atredux/store'
import { getDeviceId } from '@src/utils/DeviceUtil'

export async function getDeviceIdListener () {
    console.log('ATBase: Received request for device ID.')
    const deviceId = await getDeviceId()
    return Promise.resolve(deviceId)
}
